import React, { useEffect, useState } from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import "./slideShow.scss";
import { UseGetSlides } from "../../../core/services/api/get-slides";
import { correctUploadPath } from "../../../core/utils/image-path-correction";
import { useSelector } from "react-redux";

const SlideShow = () => {
  const state = useSelector((state) => state.setting);

  const { data, mutate } = UseGetSlides();
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    mutate({
      page: 1,
      pageSize: state.sliderImageCount,
      id: 0,
      title: null,
      description: null,
      canShow: true,
      startShowDateTime: null,
      endShowDateTime: null,
    });
  }, [state.sliderImageCount]);

  const sliderList = data?.data?.result?.sliderList || [];

  return  (
    <Container fluid className="sliderContainer">
      <Row className="g-3">
        <Col xs={12} lg={9}>
          <Carousel
            activeIndex={selectedTab}
            onSelect={(selectedIndex) => setSelectedTab(selectedIndex)}
            indicators={false}
            interval={5000}
            pause="hover"
            fade
            prevIcon={
              <div  className="arrow"  >
                <IoIosArrowBack />
              </div>
            }
            nextIcon={
              <div  className="arrow"  >
                <IoIosArrowForward />
              </div>
            }
          >
            {sliderList.map((slide, index) => (
              <Carousel.Item key={index}>
                <a href={slide?.linkAddress} className="slider-link">
                  <div className="imageWrapper">
                    <img
                      className="mainSliderImage"
                      src={
                        process.env.REACT_APP_PUBLIC_PATH +
                        "/" +
                        correctUploadPath(slide?.imagePath)
                      }
                      alt={slide?.title}
                    />

                    <div className="overlay" />

                    <Carousel.Caption className="caption">
                      <h3>{slide?.title}</h3>

                      {slide?.description && (
                        <p>{slide.description}</p>
                      )}
                    </Carousel.Caption>
                  </div>
                </a>
              </Carousel.Item>
            ))}
          </Carousel>
        </Col>

        <Col lg={3} className="d-none d-lg-block">
          <div className="thumbnailContainer">
            {sliderList.map((slide, index) => (
              <div
                key={index}
                className={`thumbnailItem ${
                  selectedTab === index ? "active" : ""
                }`}
                onClick={() => setSelectedTab(index)}
              >
                <img
                  src={
                    process.env.REACT_APP_PUBLIC_PATH +
                    "/" +
                    correctUploadPath(slide?.imagePath)
                  }
                  alt={slide?.title}
                />
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SlideShow;